export const NewsTopic = {
  CLIENT: "NEWS_TOPIC_CLIENT",
  ENTERPRISE: "NEWS_TOPIC_ENTERPRISE",
  DRIVER: "NEWS_TOPIC_DRIVER",
};
